import { useChecksStore } from '@app/application/sf-assistant-checks/stores/checks'
import { getSfAssistantChecksData } from '@app/application/sf-assistant-checks/utils'

onDomLoad(function () {
  const trigger = document.querySelector(
    '[data-behaviour="sf-assistant-trigger"]'
  )

  if (trigger) {
    const checkStore = useChecksStore()
    const data = getSfAssistantChecksData()

    if (data.showElement) {
      checkStore.triggerCalculation()
    }
  }
})
